import React from "react";
import Header from "../Header";
import AboutUs from "../AboutUs";
import RJChokhiSystem from "./RJChokhiSystem";
import OurServices from "./OurServices";
import Reservation from "./Reservation";
import Testimonials from "./Testimonials";
import WhyChooseUs from "./WhyChooseUs";
import Banner from "./Banner";
import Locations from "./Locations";

function Home() {
  return (
    <div>
      <Banner />
      <RJChokhiSystem />
      <OurServices />
      <WhyChooseUs />
      <Locations />
      {/* <Reservation /> */}
      <AboutUs
        des1=" Second Home Kitchen & Restaurant is a destination for the food
                lovers who look for authentic Rajasthani Cuisine and Punjabi
                foods. Second home Restaurant, serve the finest traditional
                Indian Cuisine served in traditional style."
        des2="Second Home Kitchen & Restaurant Established in 2017, Out of a
                passion for amazing food and service. Restaurant is one of the
                supreme multi cuisines best restaurants, now serving guests in
                both Mandsaur and Neemuch. Situated at mid in the city, the
                joint offers The best in hospitality, ambience, and
                entertainment and of course food."
      />
      <Testimonials />
    </div>
  );
}

export default Home;
